import { render, staticRenderFns } from "./ArticleEdit.vue?vue&type=template&id=7205c8dc"
import script from "./ArticleEdit.vue?vue&type=script&lang=js"
export * from "./ArticleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports